import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { InsiderTileBadgeRenderer } from "@faire/retailer-visitor-shared/components/InsiderBadge/InsiderTileBadgeRenderer";
import { MaybeBrandReviewTile } from "@faire/retailer-visitor-shared/components/MaybeBrandReviewTile/MaybeBrandReviewTile";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { BrandMinimum } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/components/BrandMinimum";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { BrandNameText } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/components/BrandNameText";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { BrandPromoText } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/components/BrandPromoText";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { SearchProductTileBrandLink } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/Links/SearchProductTileBrandLink";
import { InsiderLinkClientWrapper } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/__internal__/InsiderLinkClientWrapper";
import { MarketplaceProductBrandLinkBase } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/__internal__/SearchMarketplaceProductBrandLinkBase";
import { localNum } from "@faire/web--source/common/localization/localNum";
import { Column } from "@faire/web--source/slate/Layout/Column";
import { Row } from "@faire/web--source/slate/Layout/Row";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { CountryFlag } from "@faire/web--source/ui/CountryFlag";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import * as React from "react";
export var discoveryProductTileBrandInfoParamsILeanProductTileAdapter = function(productTileBrand) {
    var _productTileBrand_insider_label;
    return {
        token: productTileBrand.token,
        name: productTileBrand.name,
        icon: productTileBrand.icon,
        minimumOrderAmount: productTileBrand.minimum_order_amount,
        insiderBenefits: productTileBrand.insider_benefits,
        insiderLabelText: (_productTileBrand_insider_label = productTileBrand.insider_label) === null || _productTileBrand_insider_label === void 0 ? void 0 : _productTileBrand_insider_label.text,
        shipsFromMessage: productTileBrand.ships_from_message,
        flagCountryCode: productTileBrand.flag_country_code
    };
};
export var discoveryProductTileBrandInfoParamsBrandInfoPropsAdapter = function(props) {
    var _props_insiderBadgeProps, _props_insiderBadgeProps1;
    return {
        token: props === null || props === void 0 ? void 0 : props.brandToken,
        name: props === null || props === void 0 ? void 0 : props.brandName,
        icon: props === null || props === void 0 ? void 0 : props.brandIcon,
        minimumOrderAmount: props === null || props === void 0 ? void 0 : props.minimumOrderAmount,
        insiderBenefits: props === null || props === void 0 ? void 0 : (_props_insiderBadgeProps = props.insiderBadgeProps) === null || _props_insiderBadgeProps === void 0 ? void 0 : _props_insiderBadgeProps.insiderBenefits,
        insiderLabelText: props === null || props === void 0 ? void 0 : (_props_insiderBadgeProps1 = props.insiderBadgeProps) === null || _props_insiderBadgeProps1 === void 0 ? void 0 : _props_insiderBadgeProps1.insiderLabelText,
        shipsFromMessage: props === null || props === void 0 ? void 0 : props.shipsFromMessage,
        flagCountryCode: props === null || props === void 0 ? void 0 : props.flagCountryCode
    };
};
export var DiscoveryProductTileBrandInfo = function(param) {
    var brand = param.brand, shouldUseClickContext = param.shouldUseClickContext, isLoggedInRetailer = param.isLoggedInRetailer, onBrandLinkClick = param.onBrandLinkClick, generateBrandUrl = param.generateBrandUrl, dataTestId = param.dataTestId, selectedProductOptionToken = param.selectedProductOptionToken, productLinkProps = param.productLinkProps, isLoaded = param.isLoaded, avgBrandReviewRating = param.avgBrandReviewRating, brandReviewCount = param.brandReviewCount, brandPromoText = param.brandPromoText, insiderBadgeProps = param.insiderBadgeProps, isHighlightedProductForPromotionalEvent = param.isHighlightedProductForPromotionalEvent, onLinkClickHandler = param.onLinkClickHandler, brandLinkProps = param.brandLinkProps;
    var flagIcon = CountryFlag({
        country: brand.flagCountryCode,
        size: "16px"
    });
    var pdpLinkContents = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BrandMinimum, {
                minimumOrderAmount: brand.minimumOrderAmount,
                avgBrandReviewRating: avgBrandReviewRating,
                isLoggedInRetailer: isLoggedInRetailer
            }),
            insiderBadgeProps.insiderLabelText ? /*#__PURE__*/ _jsx(InsiderTileBadgeRenderer, _object_spread({}, insiderBadgeProps)) : null,
            /*#__PURE__*/ _jsx(BrandPromoText, {
                promoText: brandPromoText,
                isHighlightedPromo: isHighlightedProductForPromotionalEvent
            })
        ]
    });
    var _brand_token, _brand_name;
    var brandLinkContents = /*#__PURE__*/ _jsx(BrandNameText, {
        brandToken: (_brand_token = brand.token) !== null && _brand_token !== void 0 ? _brand_token : "",
        brandName: (_brand_name = brand.name) !== null && _brand_name !== void 0 ? _brand_name : "",
        isLoaded: isLoaded,
        brandIcon: brand.icon
    });
    var _brand_token1, _productLinkProps_productUrl;
    return /*#__PURE__*/ _jsxs(Column, {
        gap: {
            mobileAndAbove: 2,
            tabletAndAbove: 4
        },
        children: [
            brandLinkProps ? /*#__PURE__*/ _jsx(SearchProductTileBrandLink, {
                data: brandLinkProps,
                children: brandLinkContents
            }) : /*#__PURE__*/ _jsx(MarketplaceProductBrandLinkBase, {
                brandToken: (_brand_token1 = brand.token) !== null && _brand_token1 !== void 0 ? _brand_token1 : "",
                onBrandLinkClick: onBrandLinkClick,
                generateBrandUrl: generateBrandUrl,
                children: brandLinkContents
            }),
            shouldUseClickContext ? /*#__PURE__*/ _jsx(InsiderLinkClientWrapper, {
                brandToken: brand.token,
                selectedProductOptionToken: selectedProductOptionToken,
                dataTestId: dataTestId,
                children: pdpLinkContents
            }) : /*#__PURE__*/ _jsx(Link, {
                onClick: onLinkClickHandler,
                "data-test-id": dataTestId,
                to: (_productLinkProps_productUrl = productLinkProps === null || productLinkProps === void 0 ? void 0 : productLinkProps.productUrl) !== null && _productLinkProps_productUrl !== void 0 ? _productLinkProps_productUrl : "",
                replace: productLinkProps === null || productLinkProps === void 0 ? void 0 : productLinkProps.replace,
                children: pdpLinkContents
            }),
            !isLoggedInRetailer ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(MaybeBrandReviewTile, {
                        rating: ratingString(avgBrandReviewRating, brandReviewCount)
                    }),
                    flagIcon ? /*#__PURE__*/ _jsxs(Row, {
                        align: "center",
                        children: [
                            flagIcon,
                            /*#__PURE__*/ _jsx(Spacer, {
                                width: 6
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraphSansRegular",
                                children: brand.shipsFromMessage
                            })
                        ]
                    }) : null
                ]
            }) : null
        ]
    });
};
var ratingString = function(avgBrandReviewRating, brandReviewCount) {
    if (avgBrandReviewRating && brandReviewCount) {
        return "".concat(avgBrandReviewRating, " (").concat(localNum(brandReviewCount), ")");
    }
    return undefined;
};
